<template>
  <div class="employee-index">
    <transition
      name="fade"
      mode="out-in"
      @beforeLeave="beforeLeave"
      @enter="enter"
      @afterEnter="afterEnter"
    >
      <div key="1" v-if="loader" class="white-row loader-route">
        <div class="lds-sub-ripple">
          <div></div>
          <div></div>
        </div>
      </div>
      <div v-else key="1" class="white-row">
        <!-- // Filter Area -->
        <div class="general-filters">
          <div class="col-sm-12">
            <div class="row">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="row top-gen-heading">
                  <h1 class="global-style-heading">
                    All Payments
                    <a
                      @click.prevent="refreshClientTable"
                      href=""
                      class="refreshData"
                      ><i class="fas fa-redo-alt"></i
                    ></a>
                  </h1>
                </div>
              </div>
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <form @submit.prevent="getPaymentsData(1)">
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="row">
                        <div class="form-group custom-date-picker">
                          <label for="from_date">&nbsp;</label>
                          <datepicker
                            :minimumView="'day'"
                            :maximumView="'month'"
                            :initialView="'month'"
                            :format="customFormatterfromdate"
                            placeholder="From"
                            :input-class="'form-control'"
                            :clear-button="true"
                            :value="formData.from_date"
                            @cleared="onClearDateFromDate"
                          >
                            <span
                              slot="afterDateInput"
                              class="animated-placeholder"
                            >
                              <i class="far fa-calendar-alt"></i>
                            </span>
                          </datepicker>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="row">
                        <div class="form-group custom-date-picker">
                          <label for="to_date">&nbsp;</label>
                          <datepicker
                            :minimumView="'day'"
                            :maximumView="'month'"
                            :initialView="'month'"
                            :format="customFormattertodate"
                            placeholder="To"
                            :input-class="'form-control'"
                            :clear-button="true"
                            @cleared="onClearDateToDate"
                            :value="formData.to_date"
                          >
                            <span
                              slot="afterDateInput"
                              class="animated-placeholder"
                            >
                              <i class="far fa-calendar-alt"></i>
                            </span>
                          </datepicker>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="row">
                        <form @submit.prevent="">
                          <div class="form-group">
                            <label for="brand_id" class="control-label"
                              >&nbsp;</label
                            >
                            <Select2
                              @change="getPaymentsData(1)"
                              v-model="formData.brand_id"
                              :options="brand_options"
                              :settings="{
                                placeholder: 'Select Brand',
                                allowClear: true
                              }"
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="row">
                        <div class="form-group">
                          <label for="employee_id" class="control-label"
                            >&nbsp;</label
                          >
                          <Select2
                            @change="getPaymentsData(1)"
                            v-model="formData.employee_id"
                            :options="project_employees"
                            :settings="{
                              placeholder: 'Sales Person / Sales Team Lead',
                              allowClear: true
                            }"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="row">
                        <div class="form-group">
                          <label for="payment_gateway" class="control-label"
                            >&nbsp;</label
                          >
                          <Select2
                            @change="getPaymentsData(1)"
                            v-model="formData.payment_gateway"
                            :options="payment_gateway_options"
                            :settings="{
                              placeholder: 'Select Payment Method',
                              allowClear: true
                            }"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="row">
                        <div class="form-group">
                          <label for="payment_status" class="control-label"
                            >&nbsp;</label
                          >
                          <Select2
                            @change="getPaymentsData(1)"
                            v-model="formData.payment_status"
                            :options="payment_status_options"
                            :settings="{
                              placeholder: 'Select Payment Status',
                              allowClear: true
                            }"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="row">
                        <form @submit.prevent="">
                          <div class="form-group">
                            <label for="gender" class="control-label"
                              >&nbsp;</label
                            >
                            <div class="input-group">
                              <input
                                v-model="formData.search"
                                @keyup="getPaymentsData(1, 'search')"
                                type="text"
                                class="form-control"
                                placeholder="Search Client.."
                              />
                              <div class="input-group-append">
                                <button class="btn btn-secondary" type="button">
                                  <i class="fa fa-search"></i>
                                </button>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="row">
                        <div class="form-actions">
                          <button
                            type="submit"
                            class="btn btn-primary default-global-btn"
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="horizontal-row">
          <hr />
        </div>
        <div class="emp-listing">
          <transition
            name="fade"
            mode="out-in"
            @beforeLeave="beforeLeave"
            @enter="enter"
            @afterEnter="afterEnter"
          >
            <div key="1" v-if="client_loader" class="white-row loader-route">
              <div class="lds-sub-ripple">
                <div></div>
                <div></div>
              </div>
            </div>
            <div v-else class="client-page-wrapper">
              <div class="">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>ID</th>
                        <th>Project Name</th>
                        <th>Invoice</th>
                        <th>Client</th>
                        <th>Account Manager</th>
                        <th>Brand</th>
                        <th>Gateway</th>
                        <th>Amount</th>
                        <th>Transaction Id</th>
                        <th>Created At</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody
                      v-if="
                        typeof payments_list.data !== 'undefined' &&
                          Object.keys(payments_list.data).length
                      "
                    >
                      <tr
                        v-for="(payment, inv_index) in payments_list.data"
                        :key="inv_index"
                      >
                        <td>
                          {{ payment.id }}
                        </td>
                        <td>
                          <a
                            target="_blank"
                            :href="
                              main_app_url +
                                '/projects/show/' +
                                payment.project.id
                            "
                          >
                            {{ payment.project.project_name }}</a
                          >
                        </td>
                        <td>
                          <a
                            target="_blank"
                            :href="
                              main_app_url +
                                '/invoices/show/' +
                                payment.invoice.id
                            "
                          >
                            {{ payment.invoice.invoice_number }}</a
                          >
                        </td>
                        <td>
                          {{ payment.client_name.name }}
                        </td>
                        <td>
                          {{ payment.am_name.name }}
                        </td>
                        <td>
                          {{ payment.brand.name }}
                        </td>
                        <td>
                          {{ payment.gateway }}
                        </td>
                        <td>
                          {{
                            payment.currency.currency_symbol +
                              "" +
                              payment.amount
                          }}
                        </td>
                        <td>
                          {{ payment.transaction_id }}
                        </td>
                        <td>
                          {{ payment.created }}
                        </td>
                        <td>
                          {{ payment.status }}
                        </td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="11">
                          <no-record-found></no-record-found>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <!-- <div v-else class="row">
                <div class="col-sm-12">
                  <no-record-found></no-record-found>
                </div>
              </div> -->
            </div>
          </transition>

          <div class="row">
            <div class="col-sm-12">
              <pagination
                class="pagination justify-content-center"
                :data="payments_list"
                :limit="1"
                @pagination-change-page="getPaymentsData"
              ></pagination>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import Select2 from "v-select2-component";
import norecordfound from "../../../components/no-record-found";
export default {
  components: {
    Select2,
    "no-record-found": norecordfound,
    Datepicker
  },
  data() {
    return {
      copy_url: null,
      loader: true,
      client_loader: true,
      payments_list: {},
      formData: {
        search: "",
        brand_id: null,
        from_date: null,
        to_date: null,
        employee_id: null,
        payment_status: null,
        payment_gateway: null
      },
      brand_options: null,
      main_app_url: null,
      project_employees: null,
      payment_gateway_options: [
        {
          id: "paypal",
          text: "Paypal"
        },
        {
          id: "stripe",
          text: "Stripe"
        }
      ],
      payment_status_options: [
        {
          id: "complete",
          text: "Complete / Paid"
        },
        {
          id: "failed",
          text: "Failed"
        }
      ]
    };
  },
  mounted() {
    document.title =
      "PNC Work Bench - " + this.$router.app._route.meta.pageTitle;
    this.copy_url = window.app_url + "/package-form/";
    this.getemployees();
    this.getPaymentsData();
    this.getprojectbrands();
    this.loader = false;
    this.main_app_url = window.parent_app_url;
  },
  computed: {
    getActiveUserData() {
      return this.$store.state.auth;
    }
  },
  methods: {
    refreshClientTable() {
      this.getPaymentsData();
      this.getprojectbrands();
      this.loader = false;
    },
    async getemployees() {
      const $this = this;
      const data = $this.$store.dispatch("getHttp", {
        url: "/filters/get-employees"
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.project_employees = response.data.data;
        }
      });
    },
    async getprojectbrands() {
      const $this = this;
      const data = $this.$store.dispatch("getHttp", {
        url: "filters/get-project-brand"
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.brand_options = response.data.data;
        }
      });
    },
    async getPaymentsData(page = 1, action = null) {
      const $this = this;
      if (action == "search") {
        if ($this.formData.search.length < 2 && $this.formData.search != "") {
          return true;
        }
      }
      $this.client_loader = true;
      const data = $this.$store.dispatch("getHttp", {
        url:
          "all-payments?" +
          "&page=" +
          page +
          "&search=" +
          $this.formData.search +
          "&brand_id=" +
          $this.formData.brand_id +
          "&from_date=" +
          $this.formData.from_date +
          "&to_date=" +
          $this.formData.to_date +
          "&employee_id=" +
          $this.formData.employee_id +
          "&payment_status=" +
          $this.formData.payment_status +
          "&payment_gateway=" +
          $this.formData.payment_gateway +
          "&timezone=" +
          Intl.DateTimeFormat().resolvedOptions().timeZone
      });
      await data.then(function(response) {
        if (typeof response !== "undefined") {
          $this.payments_list = response.data;
        }
        $this.client_loader = false;
      });
    },
    beforeLeave(element) {
      this.prevHeight = getComputedStyle(element).height;
    },
    enter(element) {
      const { height } = getComputedStyle(element);

      element.style.height = this.prevHeight;

      setTimeout(() => {
        element.style.height = height;
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    avatarClass(managers, index) {
      if (managers.length == 1) {
        return "custom-avtr orv-3";
      } else if (managers.length == 2) {
        return "custom-avtr orv-" + (index + 2);
      } else {
        return "custom-avtr orv-" + (index + 1);
      }
    },
    onClearDateFromDate() {
      this.formData.from_date = null;
    },
    onClearDateToDate() {
      this.formData.to_date = null;
    },
    customFormatterfromdate(val) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      var new_val =
        months[val.getMonth()] + " " + val.getDate() + ", " + val.getFullYear();
      this.formData.from_date = new_val;
      return new_val;
    },
    customFormattertodate(val) {
      const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ];
      var new_val =
        months[val.getMonth()] + " " + val.getDate() + ", " + val.getFullYear();
      this.formData.to_date = new_val;
      return new_val;
    }
  }
};
</script>
<style lang="scss" scoped>
.remo-margin {
  margin: 0;
}
body .white-row.loader-route {
  top: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-property: height, opacity;
  transition-timing-function: ease;
  overflow: hidden;
}
.employee-index {
  .general-filters {
    .form-group {
      width: 95%;
      .input-group {
        input {
          border-radius: 3px !important;
          background: #f9f9f9;
          letter-spacing: 0.28px;
          font-size: 14px;
          padding: 3px 15px;
          color: #364460;
          border: none;
          font-weight: 200;
          height: auto;
        }
        button {
          background: #f9f9f9;
          color: #3b4c54;
          border: none;
          padding: 4px 8px;
        }
      }
    }
    .form-actions {
      width: 100%;
      button {
        width: 100%;
        margin-left: 0;
        padding: 5px 0;
      }
    }
    span.select2.select2-container.select2-container--default {
      width: 100% !important;
    }
  }
  .horizontal-row {
    padding: 30px 0 30px;
    hr {
      margin: 0;
    }
  }
  .wrap-box {
    background: #faf9f7;
    border-radius: 3px;
    padding: 0 20px;
    margin-bottom: 30px;
    .header-top {
      position: absolute;
      right: 26px;
      z-index: 100;
      top: 19px;
      .bp-dropdown__btn {
        border: none;
      }
      .bp-dropdown__body {
        padding: 0;
        background-color: #fff;
        box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.5);
        z-index: 9999;
        border-radius: 4px;
        border: none;
        margin-top: 10px;
        .list-group {
          .list-group-item {
            border: none;
            position: relative;
            display: block;
            border-bottom: 1px solid rgba(0, 0, 0, 0.125);
            padding: 10px 20px 10px 7px;
            text-align: left;
            a {
              color: #212529;
            }
          }
        }
      }
    }
    .emp-details {
      position: relative;
      padding: 20px 0 20px 44px;
      p {
        margin: 0;
        &.user-title {
          font-size: 12px;
        }
        &.user-email {
          font-size: 12px;
        }
      }
      .vue-avatar--wrapper.mr-3 {
        width: 32px !important;
        height: 32px !important;
        position: absolute;
        top: 23px;
        left: 0;
        span {
          letter-spacing: 0.24px;
          color: #ffffff;
          font-size: 12px;
          font-weight: bold;
        }
      }
    }
    .box-brand {
      padding-bottom: 10px;
      div {
        display: inline-block;
        vertical-align: middle;
        width: 50%;
        &.brand-para {
          p {
            margin: 0;
          }
        }
        &.text-right {
          p {
            margin: 0;
          }
        }
      }
    }
    .projects-list {
      p {
        font-weight: bold;
      }
    }
    .footer-box {
      display: block;
      position: relative;
      width: 100%;
      padding: 12px 0;
      border-top: 1px solid rgba(0, 0, 0, 0.1);
      &:first-child {
        border-top: none;
        padding-top: 2px;
      }
      .usr-role {
        p {
          margin: 0;
          letter-spacing: 0.24px;
          color: #918a82;
          font-size: 12px;
        }
      }
      .usr-role-name {
        position: absolute;
        right: -35px;
        top: 0;
        .custom-avtr {
          display: inline-block;
          position: relative;
          &.orv-1 {
          }
          &.orv-2 {
            left: -11px;
          }
          &.orv-3 {
            left: -22px;
          }
          &.orv-4 {
            left: -34px;
          }
          .vue-avatar--wrapper {
            margin: 0 !important;
            width: 25px !important;
            height: 25px !important;
            padding: 3px 4px 0 !important;
            span {
              font-size: 11px;
            }
          }
        }
        &.empty_am {
          right: 0;
        }
      }
    }
  }
  .justify-content-center {
    margin-bottom: 0;
  }
}

// Media Query Start

// Extra large devices (lg and less)
@media screen and (max-width: 1199px) {
}
// Extra large devices (md and less)
@media screen and (max-width: 991px) {
}

// Extra large devices (sm and up)
@media screen and (max-width: 767px) {
  body .top-gen-heading {
    padding-top: 10px;
    padding-bottom: 10px;
  }
}

// Extra large devices (xs and up)
@media screen and (max-width: 575px) {
  .employee-index .general-filters .form-group {
    width: 100%;
  }
}
// Extra large devices (xl, 1200px and up)
@media (min-width: 1200) {
}
</style>
